import { combineReducers } from "redux";
import { LOGOUT_SUCCESS } from "../../app/modules/Login/duck/constants";
import auth from "../../app/modules/Login/duck/reducer";
import signup from "../../app/modules/SignUp/duck/reducer";
import header from "../../app/molecules/Header/duck/reducer";
import facility from "../../app/modules/FacilityManager/ducks/reducers";
import supervisor from "../../app/modules/Supervisors/ducks/reducers";
import dashboard from "../../app/modules/AllProperties/ducks/reducers";
import addInfoReducer from "../../app/modules/AllProperties/AddProperty/ducks/reducers/addInfoReducer";
import configuration from "../../app/modules/Configurations/ducks/reducers";
import roles from "../../app/modules/RoleAndAccess/ducks/reducers";
import users from "../../app/modules/Users/ducks/reducers";
import cms from "../../app/modules/Cms/ducks/reducers";
import announcement from "../../app/modules/Announcement/ducks/reducers";
import organization from "../../app/modules/Organizations/ducks/reducers";
import subscription from "../../app/modules/Subscriptions/ducks/reducers";
import plans from "../../app/modules/Plans/ducks/reducers";
import tenants from "../../app/modules/Tenants/ducks/reducers";
import contracts from "../../app/modules/PostDatedCheques/ducks/reducers";
import technician from "../../app/modules/Technicians/ducks/reducers";
import serviceprovider from "../../app/modules/ServiceProvider/ducks/reducers";
import landlords from "../../app/modules/Individual Landlords/ducks/reducers";
import properties from "../../app/modules/Properties/ducks/reducers";

const appReducer = combineReducers({
  auth,
  header,
  signup,
  facility,
  supervisor,
  dashboard,
  addInfoReducer,
  configuration,
  roles,
  users,
  cms,
  announcement,
  organization,
  subscription,
  plans,
  tenants,
  contracts,
  technician,
  serviceprovider,
  landlords,
  properties,
});

const rootReducer = (state, action) => {
  // Clear all data in redux store to initial.
  if (action.type === LOGOUT_SUCCESS) state = undefined;

  return appReducer(state, action);
};

export default rootReducer;
